import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import useBreadcrumbs from 'use-react-router-breadcrumbs';
// material ui components
import { styled } from '@mui/system';
import { Box, Breadcrumbs, Typography } from '@mui/material';
// icons
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const CustomLink = styled(Typography)(
    ({ theme }) => `
        a {
            text-transform: capitalize;
            text-decoration: none;
            color: ${theme.palette.primary.light};
        }

    `
);

const CustomBreadcrumbs = () => {
    const location = useLocation();
    const breadcrumbs = useBreadcrumbs();
    const [crumbs, setCrumbs] = useState([]);

    const setPath = (crumbs: any) => {
        setCrumbs(crumbs);
    };

    const getPathName = (pathname: string) => {
        const foot_prints = pathname.split('/');
        return foot_prints[foot_prints.length - 1];
    };

    useEffect(() => {
        setPath(breadcrumbs);
    }, [location]);

    if (crumbs.length <= 1) {
        return null;
    }

    return (
        <>
            <Box display={'flex'} flexGrow={1}>
                <Breadcrumbs
                    separator={<NavigateNextIcon fontSize='small' />}
                    sx={{
                        '& 	.MuiBreadcrumbs-separator': {
                            mx: 0,
                        },
                    }}
                    aria-label='breadcrumb'
                    color='alpha.primary.30'>
                    {crumbs.map((crumb, key) => {
                        const pathname = decodeURIComponent(getPathName(crumb.match.pathname));
                        if (!pathname) return null;
                        return key === 1 || key === crumbs.length - 1 ? (
                            <Typography
                                sx={{
                                    fontSize: { md: 16, xs: 12 },
                                    fontWeight: key === crumbs.length - 1 ? 500 : 400,
                                    textTransform: 'capitalize',
                                }}
                                color='alpha.primary.70'
                                key={key}>
                                {pathname}
                            </Typography>
                        ) : (
                            <CustomLink
                                sx={{
                                    fontSize: { md: 16, xs: 12 },
                                    fontWeight: 400,
                                    textTransform: 'capitalize',
                                }}
                                color='alpha.primary.70'
                                key={key}>
                                <Link key={key} to={`${crumb.match.pathname}`}>
                                    {pathname}
                                </Link>
                            </CustomLink>
                        );
                    })}
                </Breadcrumbs>
            </Box>
        </>
    );
};
export default CustomBreadcrumbs;
